import { render, staticRenderFns } from "./CampaignElement.vue?vue&type=template&id=f41ec77c&scoped=true"
import script from "./CampaignElement.vue?vue&type=script&lang=js"
export * from "./CampaignElement.vue?vue&type=script&lang=js"
import style0 from "./CampaignElement.vue?vue&type=style&index=0&id=f41ec77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41ec77c",
  null
  
)

export default component.exports